define [], () ->
  name: 'applications', url: '^/applications/', public: true
  template: require("./applications.jade")
  controller: require("./applications.coffee")
  children: [
    name: 'customize', url: '^/customize/{application_template_slug}/', public: false
    params: application_template_slug: {value: null, squash: true}
    resolve:
      applicationTemplate: (ApplicationTemplate, $stateParams, $q) ->
        if $stateParams.application_template_slug
          return ApplicationTemplate.getBySlug(slug: $stateParams.application_template_slug).$promise
      stage: ->
        'customize'
    template: require("./customize/customize.jade")
    controller: require("./customize/customize.coffee")
  ,
    name: 'form_edit', url: '^/forms/{application_template_slug}/edit/', public: false
    params: application_template_slug: {value: null, squash: true}
    resolve:
      applicationTemplate: (ApplicationTemplate, $stateParams, $q) ->
        if $stateParams.application_template_slug
          return ApplicationTemplate.getBySlug(slug: $stateParams.application_template_slug).$promise
      landlord: (Landlord) ->
        Landlord.getMe().$promise.then (response) ->
          return response
    template: require("./edit/edit.jade")
    controller: require("./edit/edit.coffee")
  ,
    name: 'edit', url: '^/edit/{application_id}/', public: true
    resolve:
      app_or_apptemplate: (Application, $stateParams, $state, $q) ->
        Application.get(id: $stateParams.application_id).$promise
      stage: ->
        'edit'
    controller: require("./apply/apply.coffee")
    template: require("./apply/apply.jade")
  ,
    name: 'apply_sample', url: '^/sample/', public: true
    resolve:
      app_or_apptemplate: (ApplicationTemplate, $stateParams, $state, $q) ->
        ApplicationTemplate.getBySlug(slug: 'sample@rentapplication.net').$promise
      stage: ->
        'apply'
    controller: require("./apply/apply.coffee")
    template: require("./apply/apply.jade")
  ,
    name: 'apply', url: '^/apply/{application_slug}/', public: true
    params:
      application: null
      submission_errors: null
      params_data: null
    resolve:
      app_or_apptemplate: (ApplicationTemplate, $stateParams, $state, $q) ->
        $stateParams.application or ApplicationTemplate.getBySlug(slug: $stateParams.application_slug).$promise
      stage: ->
        'apply'
    controller: require("./apply/apply.coffee")
    template: require("./apply/apply.jade")
  ,
    name: 'apply-redirect', url: '^/{application_slug}/', public: true
    controller: ($state, $stateParams, $location) ->
      url = "/apply/#{$stateParams.application_slug}/#{window.location.search}"
      window.location.replace(url)
  ,
    name: 'create_account', url: '^/{application_slug}/create_account', public: true
    controller: require("./create_account/create_account.coffee")
    template: require("./create_account/create_account.jade")
    params:
      application: null
      params_data: null
      applicant_info: null
      view_state: null
  ,
    name: 'verify', url: 'verify/{application_id}/'
    template: require('./verify/verify.jade')
    params:
      application: null
      context: 'applicant'
      vendor: 'experian'
    children: [
      name: 'disclaimer', url: 'disclaimer/'
      controller: require("./../verifications/disclaimer/disclaimer.coffee")
      template: require("./../verifications/disclaimer/disclaimer.jade")
    ,
      name: 'personal_info', url: 'personal_info/'
      controller: require("./../verifications/personal_info/personal_info.coffee")
      template: require("./../verifications/personal_info/personal_info.jade")
    ,
      name: 'questions', url: 'questions/'
      controller: require("./../verifications/questions/questions.coffee")
      template: require("./../verifications/questions/questions.jade")
      params:
        questions: []
    ,
      name: 'verify_success', url: 'success/'
      controller: require("./../verifications/success/success.coffee")
      template: require("./../verifications/success/success.jade")
    ,
      name: 'verify_fail', url: 'fail/'
      controller: require("./../verifications/fail/fail.coffee")
      template: require("./../verifications/fail/fail.jade")
    ]
  , 
    name: 'income', url: 'income/{application_id}/', public: false
    template: require('./income/income.jade')
    controller: require('./income/income.coffee')
    params:
      application: null
  ,
    name: 'pay', url: 'pay/{application_id}/', public: true
    template: require("./pay/pay.jade")
    controller: require("./pay/pay.coffee")
  ,
    name: 'apply_success', url: 'success/{application_id}/', public: true
    params:
      application: null
      paid: false
    template: require("./success/success.jade")
    controller: require("./success/success.coffee")
  ]



// WEBPACK FOOTER //
// ./components/applications/routes.coffee